import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Crown, Medal, Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { Skeleton } from "@/components/portal/ui";

const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const monthLabel = (m) => (m ? `${MONTHS[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}` : "");
export const shiftMonth = (m, delta) => {
  const d = new Date(Number(m.slice(0, 4)), Number(m.slice(5, 7)) - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
const thisMonth = () => new Date().toISOString().slice(0, 7);
const MEDAL = ["text-amber-400", "text-slate-400", "text-orange-400"];

export default function MinistryLeaderboard() {
  const [month, setMonth] = useState(thisMonth);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/portal/ministry/leaderboard?month=${month}`).then((r) => setData(r.data)).catch(() => setData({ leaderboard: [] }));
  }, [month]);

  return (
    <div className="bg-white rounded-3xl p-5 border border-slate-100 shadow-sm" data-testid="ministry-leaderboard">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-extrabold text-slate-900 flex items-center gap-2 min-w-0"><Trophy className="w-4 h-4 text-amber-500 shrink-0" /><span className="truncate">Papan Peringkat</span></p>
        <div className="flex items-center shrink-0">
          <button onClick={() => setMonth((m) => shiftMonth(m, -1))} data-testid="leaderboard-prev-month" className="w-7 h-7 rounded-lg grid place-items-center text-slate-500 hover:bg-slate-100"><ChevronLeft className="w-4 h-4" /></button>
          <span className="text-[10px] font-bold text-slate-600 tabular-nums whitespace-nowrap" data-testid="leaderboard-month">{monthLabel(month)}</span>
          <button disabled={month >= thisMonth()} onClick={() => setMonth((m) => shiftMonth(m, 1))} data-testid="leaderboard-next-month" className="w-7 h-7 rounded-lg grid place-items-center text-slate-500 hover:bg-slate-100 disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
        </div>
      </div>
      {!data ? <Skeleton className="h-40 mt-4" /> : data.leaderboard.length === 0 ? (
        <p className="mt-3 text-sm text-slate-500" data-testid="leaderboard-empty">Belum ada kehadiran pelayanan tercatat bulan ini.</p>
      ) : (
        <>
          <p className="mt-1 text-xs text-slate-500">{data.servants} pelayan · {data.total_served} kehadiran pelayanan</p>
          <div className="mt-3 divide-y divide-slate-50">
            {data.leaderboard.map((s) => (
              <div key={s.user_id} className="py-2.5 flex items-center gap-3" data-testid={`leaderboard-row-${s.rank}`}>
                <span className={`w-7 shrink-0 text-center font-black tabular-nums ${s.rank <= 3 ? MEDAL[s.rank - 1] : "text-slate-300"}`}>
                  {s.rank === 1 ? <Crown className="w-5 h-5 mx-auto" /> : s.rank <= 3 ? <Medal className="w-5 h-5 mx-auto" /> : s.rank}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-bold text-slate-900 truncate">{s.name}</span>
                  <span className="block text-[11px] text-slate-400 truncate">{s.roles.join(" · ") || "Pelayan"}{s.divisions > 1 ? ` · ${s.divisions} divisi` : ""}</span>
                </span>
                <span className="shrink-0 text-right">
                  <span className="block text-sm font-black text-blue-600 tabular-nums">{s.served}x</span>
                  <span className="block text-[10px] text-slate-400">{s.rate}% hadir</span>
                </span>
              </div>
            ))}
          </div>
          {data.me && (
            <div className="mt-3 rounded-2xl bg-blue-600 text-white px-4 py-3 flex items-center justify-between" data-testid="leaderboard-me">
              <span className="text-sm font-bold">Peringkat Anda #{data.me.rank}</span>
              <span className="text-sm font-black tabular-nums">{data.me.served}x · {data.me.rate}%</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
